import "core-js/modules/es6.function.name";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "footer-wrapper"
  }, [_c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "related-platforms"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("友情链接")]), _vm._v(" "), _vm._l(_vm.labelList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "name",
      on: {
        click: function click($event) {
          return _vm.open(item);
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]);
  })], 2), _vm._v(" "), _c("div", {
    staticClass: "recommend"
  }, [_c("div", {
    staticClass: "recommend-left"
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "item"
    }, [_c("div", {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c("div", {
      staticClass: "list"
    }, _vm._l(item.content, function (child, i) {
      return _c("div", {
        key: "".concat(index, "-").concat(i),
        staticClass: "name",
        on: {
          click: function click($event) {
            return _vm.open(child);
          }
        }
      }, [_vm._v("\n              " + _vm._s(child.name) + "\n            ")]);
    }), 0)]);
  }), 0), _vm._v(" "), _vm._m(0)])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "qrcode-list"
  }, [_c("div", {
    staticClass: "qrcode-wrapper"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/index/wxapp-dialog/public.png"),
      alt: ""
    }
  }), _vm._v(" "), _c("span", [_vm._v("扫码关注公众号")])]), _vm._v(" "), _c("div", {
    staticClass: "qrcode-wrapper"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/index/wxapp-dialog/qrcode.webp"),
      alt: ""
    }
  }), _vm._v(" "), _c("span", [_vm._v("扫码使用小程序")])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };